import { BehaviorSubject } from 'rxjs';

import Resource from '../models/Resource';

export default class MaterialRepository {
  materials$ = new BehaviorSubject([]);
  modalities$ = new BehaviorSubject([]);
  materialCount$ = new BehaviorSubject(0);
  anatomies$ = new BehaviorSubject([]);
  tags$ = new BehaviorSubject([]);
  loading$ = new BehaviorSubject(false);

  constructor({ materialService }) {
    this.materialService = materialService;
  }

  async getMaterials(criteria) {
    try {
      this.loading$.next(true);

      const materials = await this.materialService.getMaterials(criteria);
      this.materials$.next(materials?.data?.map((material) => new Resource(material)));
      this.materialCount$.next(materials?.total);

      this.loading$.next(false);

      return materials;
    } catch (error) {
      this.loading$.next(false);

      return [];
    }
  }

  async getAnatomies() {
    try {
      this.loading$.next(true);

      const anatomies = await this.materialService.getAnatomies();
      this.anatomies$.next(anatomies);

      this.loading$.next(false);
    } catch (error) {
      this.loading$.next(false);
      throw error;
    }
  }

  async getModalities() {
    try {
      this.loading$.next(true);

      const modalities = await this.materialService.getModalities();
      this.modalities$.next(modalities);

      this.loading$.next(false);
    } catch (error) {
      this.loading$.next(false);
      throw error;
    }
  }

  async getTags() {
    try {
      this.loading$.next(true);

      const tags = await this.materialService.getTags();
      this.tags$.next(tags.data);

      this.loading$.next(false);
    } catch (error) {
      this.loading$.next(false);
      throw error;
    }
  }

  getMaterialDetails(id) {
    return this.materialService.getMaterialDetails(id);
  }

  async createMaterial(payload, progress$ = new BehaviorSubject(0)) {
    await this.materialService.createMaterial(payload, progress$);
  }

  async updateMaterial(payload, id, progress$ = new BehaviorSubject(0)) {
    await this.materialService.updateMaterial(payload, id, progress$);
  }

  async deleteMaterial(id) {
    await this.materialService.deleteMaterial(id);
  }
}
